<template>

</template>

<script>
    export default {
        name: "denetci"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/ozel/denetci.vue